import { render } from "./eSesjaLogo.vue?vue&type=template&id=117fab3c"
import script from "./eSesjaLogo.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./eSesjaLogo.vue?vue&type=script&charset=utf-8&lang=js"

import "./eSesjaLogo.vue?vue&type=style&index=0&id=117fab3c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__